import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Subscription, of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { editableRole } from 'src/app/helpers/enums/role-type.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { InformationService } from 'src/app/services/information/information.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { DualList } from './dualList.state';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  providers: [DualList],
  styles: [
    `
      :host > .record-picker {
        border-radius: 0 !important;
        scrollbar-width: thin;
      }

      :host > div.record-picker::-webkit-scrollbar {
        width: 10px !important;
        border-radius: 0 !important;
      }

      :host > div.record-picker::-webkit-scrollbar-track {
        width: 10px !important;
        border-radius: 0 !important;
      }

      :host > div.record-picker::-webkit-scrollbar-thumb {
        width: 10px !important;
        border-radius: 0 !important;
        border: 0 !important;
        background-color: #fff !important;
      }

      :host > .listbox .record-picker li {
        padding: 5px 40px 5px 5px !important;
        border-radius: 0 !important;
        border: none !important;
        /* background: url('/assets/images/icons8-add.svg') no-repeat;
        background-size: 20px;
        background-position: center right 15px; */
        overflow-x: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
        cursor: pointer;
      }

      :host > .listbox .record-picker li.selected {
        color: #fff;
        background-color: #161c24 !important;
      }

      :host > .listbox .record-picker li:hover {
        color: #fff;
        background-color: #161c24 !important;
      }

      :host > .listbox .record-picker li:nth-child(even) {
        background-color: #fff5e3;
      }

      :host > .listbox .record-picker li:nth-child(odd) {
        background-color: #ffe3b0;
      }

      :host > .dual-list button.btn-block {
        margin: 0;
        border-radius: 5px 5px 0 0;
        background-color: #161c24 !important;
        border-color: #161c24 !important;
        box-shadow: none !important;
      }

      :host > .dual-list button.btn-block:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      :host > .dual-list .button-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      :host > .dual-list .button-bar button {
        width: 49% !important;
      }

      :host > .dual-list .button-bar button:not(:disabled) {
        color: #fff;
        background-color: #f9b22a;
        border-color: #f9b22a;
        box-shadow: none !important;
      }

      :host > .dual-list .button-bar button:not(:disabled):active {
        background-color: #e09d1f;
      }

      :host > .dual-list .button-bar button:disabled {
        color: #fff;
        background-color: #242e3a;
        border-color: #242e3a;
        opacity: 0.3;
        cursor: not-allowed;
      }

      :host > .card,
      :host > .card-header {
        padding: 0;
        border: none;
        background-color: transparent;
      }

      :host > .panel-body {
        padding: 0;
        border: 1px solid #242e3a;
      }
    `
  ]
})
export class OptionsComponent implements OnInit {
  public loaded: boolean = false;
  public submitLoaded = false;
  public userData: string = null;
  public role: string = null;
  public lang: string = null;
  public optionsForm: UntypedFormGroup = null;
  public options: any[] = [];
  public savedOptions: any[] = [];
  public collectedOptions: any[] = [];
  public informationObj: Object = {};
  public itemCode: string = null;
  public disableForm: boolean = false;
  public editableRole: string[] = [];
  public modalRef: BsModalRef;
  @ViewChild('vehicleInfo', { static: false }) vehicleInfo: TemplateRef<any>;

  public subscriptions: Subscription[] = [];

  constructor(
    public formBuilder: UntypedFormBuilder,
    public modalService: BsModalService,
    public router: Router,
    public dualList: DualList,
    public authService: AuthService,
    public userService: UserService,
    public estimateService: EstimatesService,
    public sharedService: SharedService,
    public localeService: LocaleService,
    public informationService: InformationService
  ) {
    this.getUserData();
    this.editableRole = editableRole;
    this.optionsForm = this.formBuilder.group({
      more_information: ['']
    });
  }

  ngOnInit(): void {
    this.localeService.localeSubject.subscribe((res) => {
      this.lang = res;
      this.getOptions();
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.informationObj = res) : (this.informationObj = null);
    });

    // START => getting report status of a vehicle from API the disable the form
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
      const vehicleStatus = Object.values(res['data']);

      // this.disableForm = res['data']['gallery'];
      // vehicleStatus.every((status: boolean) => status === true)
      if (this.disableForm === true && !editableRole.includes(this.role)) {
        this.optionsForm.disable();
      }
    });
    // END
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription, index: number) => {
      subscription.unsubscribe();
    });
  }

  getUserData() {
    const userDataSub = this.authService.userSubject.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
    });

    this.subscriptions.push(userDataSub);
  }

  getOptions() {
    this.loaded = true;

    const optionsSub = this.userService.GetOptions().subscribe((res) => {
      const success: boolean = res['success'];
      const data = res['data'];

      if (success) {
        this.loaded = false;
        this.options = data;

        this.options = this.options.map((item: any) => ({
          data:
            typeof item.data === 'object'
              ? item.data.map((itemInner: any) => ({
                  data: itemInner.data,
                  key: itemInner.option_id,
                  title: itemInner.option_name,
                  arabic_title: itemInner.option_name_arabic
                }))
              : item.data || item.option_name,
          key: item.option_id,
          title: item.option_name,
          arabic_title: item.option_name_arabic
        }));
        setTimeout(() => {
          this.getInfo();
        }, 0);
      }
    });
    this.subscriptions.push(optionsSub);
  }

  getInfo() {
    const vehicle_id = { vehicle_id: this.sharedService.getVehicleId };
    this.userService.GetVinInfo(vehicle_id).subscribe(
      (res) => {
        let success = res['success'];
        let data = res['data'];

        if (success && Object.keys(data).length) {
          let vehicleSelectedOptions: object = data['vehicle_options_data']
            ? data['vehicle_options_data']
            : {};

          this.optionsForm
            .get('more_information')
            .setValue(vehicleSelectedOptions['more_information']);
          this.optionsForm.updateValueAndValidity();

          this.manageSelection(this.options, vehicleSelectedOptions['options']);
        }
      },
      (error) => {}
    );
  }

  manageSelection(options: any[], ...args: any[]) {
    let [selection] = args;

    if (selection && selection.length) {
      this.collectedOptions = [...selection];
      this.dualList.selectionManager(options, selection);
    }
    // else {
    //   this.sharedService.options.subscribe(
    //     (res: any) => {
    //       if (res && res.selected) {
    //       //         this.collectedOptions = [ ...res.selected ];
    //         this.dualList.selectionManager(options, res.selected);
    //       }
    //     }
    //   );
    // }
  }

  selectGroupedItem(evt: any, ...args: any[]) {
    const [dataObj, mainObj] = args;
    let extractedData: any = dataObj;

    this.dualList.selectGrouped(dataObj, mainObj, this.options);

    // Data handling for POST
    setTimeout(() => {
      if (this.collectedOptions.length) {
        let keyIndex: any = this.collectedOptions.findIndex(
          (item: any) => item.key === mainObj.key
        );

        if (keyIndex !== -1) {
          this.collectedOptions[keyIndex].data = [...this.dualList.selected[keyIndex].data];
        } else {
          this.collectedOptions.push({
            data: [extractedData],
            key: mainObj.key,
            title: mainObj.title,
            arabic_title: mainObj.arabic_title
          });
        }
      } else {
        this.collectedOptions.push({
          data: [extractedData],
          key: mainObj.key,
          title: mainObj.title,
          arabic_title: mainObj.arabic_title
        });
      }
    }, 0);
  }

  deselectGroupedItem(evt: any, ...args: any[]) {
    const [dataObj, mainObj] = args;
    let extractedData: any = dataObj;

    this.dualList.deselectGrouped(dataObj, mainObj, this.options);

    setTimeout(() => {
      if (this.collectedOptions.length) {
        let keyIndex: any = this.collectedOptions.findIndex(
          (item: any) => item.key === mainObj.key
        );
        let indexedOption: any = this.collectedOptions[keyIndex];

        indexedOption.data = indexedOption.data.filter((item: any) => item !== extractedData);

        if (!indexedOption.data.length) {
          this.collectedOptions.splice(keyIndex, 1);
        }
      }
    }, 0);
  }

  selectItem(evt: any, ...args: any[]) {
    const [dataObj, type] = args;
    let extractedData: any = null;

    extractedData = dataObj;
    this.dualList.select(dataObj, this.options);

    setTimeout(() => {
      this.collectedOptions.push(extractedData);
    }, 0);
  }

  deselectItem(evt: any, ...args: any[]) {
    const [dataObj, type] = args;
    let extractedData: any = dataObj;

    this.dualList.deselect(dataObj, this.options);

    setTimeout(() => {
      this.collectedOptions = this.collectedOptions.filter(
        (item: any) => item.key !== extractedData.key
      );
    }, 0);
  }

  saveData() {
    if (!this.collectedOptions.length) {
      return false;
    } else {
      const optionsObj: Object = {
        vehicle_id: this.sharedService.getVehicleId,
        options: this.collectedOptions,
        ...this.optionsForm.value
      };
      const optionMainObj: OptionData = {
        vehicle_id: this.sharedService.getVehicleId,
        vehicle_options_data: JSON.stringify(optionsObj)
      };

      this.submitLoaded = true;
      this.userService
        .SaveOptions(optionMainObj)
        .pipe(
          switchMap((res) =>
            res['success']
              ? this.role === 'evaluator'
                ? this.estimateService.updateRevamCount({
                    vehicle_id: this.sharedService.getVehicleId
                  })
                : of(null)
              : EMPTY
          ),
          tap(() => {
            // this.collectedOptions = []; //Resetting the main collection after submit.

            // Storing in localStorage
            // this.sharedService.setOptions = {
            //   selected: this.dualList.selected,
            // };

            //Implementing modal for showing vehicle information
            this.modalRef = this.modalService.show(
              this.vehicleInfo,
              Object.assign({}, { class: 'modal-xl optionsModal' })
            );
          }),
          finalize(() => {
            this.submitLoaded = false;
          })
        )
        .subscribe({
          error: () => {}
        });
    }
  }

  dataTypeChecker(data: any) {
    switch (typeof data) {
      case 'string':
        return 'string';

      case 'object':
        return 'object';

      default:
        console.error(`Unknown data type. --> ${data}`);
        return undefined;
    }
  }

  redirectToFlag() {
    this.modalRef.hide();
    this.router.navigate(['/vam/flags']);
  }
}

interface OptionData {
  vehicle_id: string;
  vehicle_options_data: Object;
}
